import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';

const Document = styled.img`
    display: none;
    height: 70px;
    width: fit-content;
    background-color: #000;
    border-radius: 10px;
    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }
`;

const Description = styled.div`
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary};
    margin-bottom: 10px;
    @media only screen and (max-width: 768px) {
        font-size: 12px;
    }
`;

const Span = styled.span`
    overflow: hidden;
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
`;

const CardContainer = styled.div`
    position: relative;
    opacity: 0;
    transition: opacity 0.6s ease-out;

`;

const Card = styled.div`
    width: 650px;
    max-width: 700px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    transition: all 0.3s ease-in-out;
    background: rgb(29, 24, 54);
    color: rgb(255, 255, 255);

    &:hover {
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
        transform: translateY(-5px);
    }

    @media only screen and (max-width: 768px) {
        padding: 10px;
        gap: 8px;
        max-width: 250px;
    }

    
`;

const Arrow = styled.div`
    position: absolute;
    left: -20px;
    top: 25px;
    transform: translateY(-50%);
    border: solid transparent;
    border-width: 10px;
    border-right-color: white;
    opacity: 0;
    transition: opacity 0.6s ease-out;
`;

const Top = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
`;

const Image = styled.img`
    height: 60px;
    width: 60px; 
    background-color: #000;
    border-radius: 10px;
    margin-top: 4px;
    object-fit: cover; 
    @media only screen and (max-width: 768px) {
        height: 40px;
        width: 40px; 
    }
`;


const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const Role = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.text_primary + 99};
    @media only screen and (max-width: 768px){
        font-size: 14px;
    }
`;

const Company = styled.p`
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.text_secondary};
    margin: 0;
    @media only screen and (max-width: 768px) {
        font-size: 14px;
    }
`;

const DateText = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    @media only screen and (max-width: 768px) {
        font-size: 10px;
    }
`;

const Skills = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
    margin-top: -10px;
`;

const ItemWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

const Skill = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary};
    @media only screen and (max-width: 768px) {
        font-size: 12px;
    }
`;

const ExperienceCard = ({ experience }) => {
    const cardRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 1 }
        );

        if (cardRef.current) {
            observer.observe(cardRef.current);
        }

        return () => {
            if (cardRef.current) {
                observer.unobserve(cardRef.current);
            }
        };
    }, []);

    return (
        <CardContainer ref={cardRef} style={{ opacity: isVisible ? 1 : 0 }}>
            <Arrow style={{ opacity: isVisible ? 1 : 0 }} />
            <Card>
                <Top>
                    <Image src={experience.img} />
                    <Body>
                        <Role>{experience.role}</Role>
                        <Company>{experience.company}</Company>
                        <DateText>{experience.date}</DateText>
                    </Body>
                </Top>
                <Description>
                    {experience?.desc && <Span>{experience?.desc}</Span>}
                    {experience?.skills && (
                        <>
                            <br />
                            <Skills>
                                <b>Skills:</b>
                                <ItemWrapper>
                                    {experience?.skills?.map((skill, index) => (
                                        <Skill key={index}>• {skill}</Skill>
                                    ))}
                                </ItemWrapper>
                            </Skills>
                        </>
                    )}
                </Description>
                {experience.doc && (
                    <a href={experience.doc} target="_blank" rel="noopener noreferrer">
                        <Document src={experience.doc} />
                    </a>
                )}
            </Card>
        </CardContainer>
    );
};

export default ExperienceCard;
